module.exports = __webpack_public_path__ + "static/media/large_product.cda3acea.JPG";